import { useTranslation } from 'next-i18next';
import { useRequest } from '../../hooks/useRequest';
import { clientGetNewsPage } from '../../api/newsApi';

export function useNewsRelatedData(currNewsNo: string, lanType: string, category: number) {
  const { t } = useTranslation('common');

  const newsRelatedConfig: {
    newsTitleText: string;
    newsMoreText: string;
  } = t('newsRelatedConfig', { returnObjects: true });

  const { res } = useRequest(clientGetNewsPage, {
    params: { pageNo: 1, pageSize: 10, lanType, newsClassifyId: category },
  });
  const { pageContent = [] } = res || {};

  /* 剔除当前新闻 */
  const newsData = pageContent?.filter(({ newsNo }) => newsNo !== currNewsNo).slice(0, 3) || [];

  /* 有效的相关新闻有三条才展示该模块 */
  const showRelatedNews = newsData?.length >= 3;

  return {
    newsData,
    showRelatedNews,
    ...newsRelatedConfig,
  };
}
